__turbopack_context__.v({
  "actions": "CookieConsent-module-scss-module__uUHxIG__actions",
  "banner": "CookieConsent-module-scss-module__uUHxIG__banner",
  "btnAccept": "CookieConsent-module-scss-module__uUHxIG__btnAccept",
  "btnDecline": "CookieConsent-module-scss-module__uUHxIG__btnDecline",
  "description": "CookieConsent-module-scss-module__uUHxIG__description",
  "header": "CookieConsent-module-scss-module__uUHxIG__header",
  "iconWrap": "CookieConsent-module-scss-module__uUHxIG__iconWrap",
  "overlay": "CookieConsent-module-scss-module__uUHxIG__overlay",
  "policyLink": "CookieConsent-module-scss-module__uUHxIG__policyLink",
  "slideUp": "CookieConsent-module-scss-module__uUHxIG__slideUp",
  "title": "CookieConsent-module-scss-module__uUHxIG__title",
});
